import React from 'react'
import SearchIcon from './SearchIcon'

interface SearchInputProps {
  currentValue: string
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  placeholder?: string
  required?: boolean
  isExpanded?: boolean
  activeDescendant?: string | null
  listboxId?: string
}

const SearchInput: React.FC<SearchInputProps> = ({
  currentValue,
  handleChange,
  handleKeyDown,
  placeholder,
  required = false,
  isExpanded = false,
  activeDescendant = null,
  listboxId = 'supplier-search-listbox'
}) => {
  const descendantId = activeDescendant ?? ''
  const ariaActiveDescendant = descendantId !== '' ? descendantId : undefined
  return (
    <div className='input-group-search'>
      <SearchIcon />
      <input
        className='input-field-search'
        aria-label='dynamic-input-label'
        aria-required={required}
        aria-expanded={isExpanded ? 'true' : 'false'}
        aria-activedescendant={ariaActiveDescendant}
        aria-controls={listboxId}
        aria-autocomplete='list'
        role='combobox'
        autoComplete='off'
        autoFocus
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        type='text'
        value={currentValue}
      />
    </div>
  )
}

export default SearchInput
